'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasGivenConsentToCommunicate = exports.getHasGivenConsentToProcess = exports.getConsentToCommunicateMessage = exports.getConsentToProcessMessage = exports.isSystemOnline = exports.getColoring = exports.getSessionId = exports.getResponder = exports.getAwayMessage = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _deprecateFunction = require('../lib/deprecateFunction');

var _deprecateFunction2 = _interopRequireDefault(_deprecateFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY_PATHS = {
  SYSTEM_ONLINE: ['systemOnline'],
  COLORING: ['coloring'],
  CUSTOM_AWAY_MESSAGE: ['message', 'customAwayMessage'],
  SESSION_ID: ['sessionId'],
  CONSENT_TO_PROCESS_MESSAGE: ['message', 'customConsentToProcessMessage'],
  CONSENT_TO_COMMUNICATE_MESSAGE: ['message', 'customConsentToCommunicateMessage'],
  HAS_GIVEN_CONSENT_TO_PROCESS: ['hasVisitorGivenConsentToProcess'],
  HAS_GIVEN_CONSENT_TO_COMMUNICATE: ['hasVisitorGivenConsentToCommunicate']
};

var getAwayMessage = exports.getAwayMessage = (0, _pipe2.default)((0, _getIn2.default)(KEY_PATHS.CUSTOM_AWAY_MESSAGE), function (awayMessage) {
  return awayMessage || _I18n2.default.text('conversationsUI.default.awayMessage');
});

var getResponder = exports.getResponder = (0, _deprecateFunction2.default)('`getResponder` will be removed soon', (0, _getIn2.default)(KEY_PATHS.RESPONDER));

var getSessionId = exports.getSessionId = (0, _getIn2.default)(KEY_PATHS.SESSION_ID);

var getColoring = exports.getColoring = (0, _getIn2.default)(KEY_PATHS.COLORING);

var isSystemOnline = exports.isSystemOnline = (0, _getIn2.default)(KEY_PATHS.SYSTEM_ONLINE);

var getConsentToProcessMessage = exports.getConsentToProcessMessage = (0, _getIn2.default)(KEY_PATHS.CONSENT_TO_PROCESS_MESSAGE);
var getConsentToCommunicateMessage = exports.getConsentToCommunicateMessage = (0, _getIn2.default)(KEY_PATHS.CONSENT_TO_COMMUNICATE_MESSAGE);
var getHasGivenConsentToProcess = exports.getHasGivenConsentToProcess = (0, _getIn2.default)(KEY_PATHS.HAS_GIVEN_CONSENT_TO_PROCESS);
var getHasGivenConsentToCommunicate = exports.getHasGivenConsentToCommunicate = (0, _getIn2.default)(KEY_PATHS.HAS_GIVEN_CONSENT_TO_COMMUNICATE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/models/WidgetDataModel.js
// module id = 128
// module chunks = 2 3